import { Badge } from '@/components/ui/badge';
import GenericSearchBar from '../search/GenericSearchBar';
import { getPersonSuggestions } from '../../services/apiService';
import { FACULTY_COLORS, DEFAULT_NODE_COLOR } from '../graph/graphConfig';
import type { PersonSuggestion } from '../../types/api';
import type { PeopleFilters } from './PeopleFilterRow';

type Op = 'AND' | 'OR';

interface PersonSearchBarProps {
  filters?: PeopleFilters;
  onSearch?: (keywords: string[], ops: Op[]) => void;
  initialValue?: string;
}

export default function PersonSearchBar({ filters, onSearch, initialValue }: PersonSearchBarProps = {}) {
  return (
    <GenericSearchBar<PersonSuggestion>
      namespace="person"
      destinationPath="/people"
      detailPath={(s) => `/person/${encodeURIComponent(s.id)}`}
      suggestionsHeadingKey="command.peopleHeading"
      fetchSuggestions={getPersonSuggestions}
      renderSuggestionItem={(s, { highlight }) => {
        const abbr = s.faculty_abbr ?? '';
        const facultyColor = abbr ? FACULTY_COLORS[abbr] || DEFAULT_NODE_COLOR : null;
        return (
          <>
            <span className="flex-1 truncate">{highlight(s.name)}</span>
            {abbr && facultyColor && (
              <span
                className="inline-flex shrink-0 items-center rounded px-1.5 py-0.5 text-[10px] font-semibold tracking-wide text-white"
                style={{ backgroundColor: facultyColor }}
              >
                {abbr}
              </span>
            )}
          </>
        );
      }}
      filters={filters}
      onSearch={onSearch}
      initialValue={initialValue}
    />
  );
}
